// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { HiMenu, HiX } from "react-icons/hi";
// import LanguageToggle from "./LanguageToggle";

// export default function Navbar() {
//   const [open, setOpen] = useState(false);

//   return (
//     <nav className="bg-blue-700 text-white shadow-lg">
//       <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

//         {/* LOGO */}
//         <div className="text-xl font-bold tracking-wide">
//           MeruRam Company
//         </div>

//         {/* Desktop Menu */}
//         <div className="hidden md:flex space-x-6 font-medium">
//           <Link to="/" className="hover:text-yellow-300">Home</Link>
          
//           <Link to="/lottery" className="hover:text-yellow-300">Lottery Registration</Link>
//           <Link to="/shop" className="hover:text-yellow-300">Shop Now</Link>
                    
//             <Link to="/legal" className="hover:text-yellow-300">Legal</Link>

//           <Link to="/dashboard" className="hover:text-yellow-300">Dashboard</Link>
//           <Link to="/admin" className="hover:text-yellow-300">Admin</Link>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           className="md:hidden text-3xl"
//           onClick={() => setOpen(true)}
//         >
//           <HiMenu />
//         </button>
//       </div>

//       {/* Mobile Menu Overlay */}
//       {open && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setOpen(false)}></div>
//       )}

//       {/* Mobile Sliding Menu */}
//       <div
//         className={`fixed top-0 right-0 w-64 h-full bg-blue-800 text-white z-50 transform ${
//           open ? "translate-x-0" : "translate-x-full"
//         } transition-transform duration-300`}
//       >
//         <div className="p-4 flex justify-between items-center border-b border-blue-600">
//           <h2 className="text-lg font-semibold">Menu</h2>
//           <button onClick={() => setOpen(false)} className="text-3xl">
//             <HiX />
//           </button>
//         </div>

//         <div className="p-4 flex flex-col space-y-4 text-lg">
//           <Link to="/" onClick={() => setOpen(false)}>Home</Link>
//           <Link to="/lottery" onClick={() => setOpen(false)}>Lottery Registration</Link>
//             <Link to="/shop" onClick={() => setOpen(false)}>Shop Now</Link>
//           <Link to="/legal" onClick={() => setOpen(false)}>Legal</Link>
//           <Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
//           <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link>
//         </div>
//       </div>
//       <LanguageToggle/>
//     </nav>
//   );
// }



// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { HiMenu, HiX } from "react-icons/hi";
// import LanguageToggle from "./LanguageToggle";

// export default function Navbar() {
//   const [open, setOpen] = useState(false);
//   const location = useLocation();

//   // Check if link is active
//   const isActive = (path) => location.pathname === path;

//   return (
//     <nav className="bg-[#011B8A] text-white shadow-lg font-[600] tracking-wide">
//       <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">

//         {/* LOGO */}
//         <div className="text-xl font-bold">www.meruram.in</div>

//         {/* Desktop Menu */}
//         <div className="hidden md:flex space-x-6 text-lg">

//           {/** NAV ITEMS */}
//           <Link
//             to="/"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Home
//           </Link>

//           {/* <Link
//             to="/about"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/about") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             About Us
//           </Link> */}

//           <Link
//             to="/lottery"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/lottery") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Lucky Draw Registration 
//           </Link>

//             <Link
//             to="/gallary"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/shop") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//            Gallary
//           </Link>

//           <Link
//             to="/shop"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/shop") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Shop Now
//           </Link>

//           <Link
//             to="/legal"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/legal") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Legal
//           </Link>

//           <Link
//             to="/dashboard"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/dashboard") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Dashboard
//           </Link>
// {/* 
//           <Link
//             to="/admin"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/admin") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             Admin
//           </Link> */}
//         </div>

//         {/* Mobile Menu Button */}
//         <button className="md:hidden text-3xl" onClick={() => setOpen(true)}>
//           <HiMenu />
//         </button>
//       </div>

//       {/* Mobile Overlay */}
//       {open && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-40"
//           onClick={() => setOpen(false)}
//         ></div>
//       )}

//       {/* Mobile Sliding Menu */}
//       <div
//         className={`fixed top-0 right-0 w-64 h-full bg-[#021066] text-white z-50 transform 
//           ${open ? "translate-x-0" : "translate-x-full"} 
//           transition-transform duration-300`}
//       >
//         <div className="p-4 flex justify-between items-center border-b border-blue-800">
//           <h2 className="text-lg font-semibold">Menu</h2>
//           <button onClick={() => setOpen(false)} className="text-3xl">
//             <HiX />
//           </button>
//         </div>

//         <div className="p-4 flex flex-col space-y-4 text-lg">

//           {/** MOBILE LINKS */}
//           <Link to="/" onClick={() => setOpen(false)}>Home</Link>
//           {/* <Link to="/about" onClick={() => setOpen(false)}>About Us</Link> */}
//           <Link to="/lottery" onClick={() => setOpen(false)}>Lucky Draw Registration 
// </Link>
//           <Link to="/gallary" onClick={() => setOpen(false)}>Gallery</Link>

//           <Link to="/shop" onClick={() => setOpen(false)}>Shop Now</Link>
//           <Link to="/legal" onClick={() => setOpen(false)}>Legal</Link>
//           <Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
//           {/* <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link> */}
//         </div>
//       </div>

//       <div className="px-4 py-2">
//         <LanguageToggle />
//       </div>
//     </nav>
//   );
// }


// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { HiMenu, HiX } from "react-icons/hi";
// import LanguageToggle from "./LanguageToggle";
// import { useTranslation } from "react-i18next";

// export default function Navbar() {
//   const [open, setOpen] = useState(false);
//   const location = useLocation();
//   const { t } = useTranslation();

//   // Check if link is active
//   const isActive = (path) => location.pathname === path;

//   return (
//     <nav className="bg-[#011B8A] text-white shadow-lg font-[600] tracking-wide">
//       <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
//         {/* LOGO */}
//         <div className="text-xl font-bold">www.meruram.in</div>

//         {/* Desktop Menu */}
//         <div className="hidden md:flex space-x-6 text-lg">
//           <Link
//             to="/"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("home")}
//           </Link>

//           <Link
//             to="/lottery"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/lottery") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("lottery_registration")}
//           </Link>

//           <Link
//             to="/gallary"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/gallary") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("gallery")}
//           </Link>

//           <Link
//             to="/shop"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/shop") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("shop_now")}
//           </Link>

//           <Link
//             to="/legal"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/legal") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("legal")}
//           </Link>
          
//           <Link
//             to="/terms"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/legal") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("Terms and Conditions")}
//           </Link>


//           <Link
//             to="/dashboard"
//             className={`px-3 py-1 rounded-md transition-all 
//               ${isActive("/dashboard") ? "bg-blue-600" : "hover:text-yellow-300"}`}
//           >
//             {t("dashboard")}
//           </Link>
//         </div>

//         {/* Mobile Menu Button */}
//         <button className="md:hidden text-3xl" onClick={() => setOpen(true)}>
//           <HiMenu />
//         </button>
//       </div>

//       {/* Mobile Overlay */}
//       {open && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-40"
//           onClick={() => setOpen(false)}
//         ></div>
//       )}

//       {/* Mobile Sliding Menu */}
//       <div
//         className={`fixed top-0 right-0 w-64 h-full bg-[#021066] text-white z-50 transform 
//           ${open ? "translate-x-0" : "translate-x-full"} 
//           transition-transform duration-300`}
//       >
//         <div className="p-4 flex justify-between items-center border-b border-blue-800">
//           <h2 className="text-lg font-semibold">{t("menu")}</h2>
//           <button onClick={() => setOpen(false)} className="text-3xl">
//             <HiX />
//           </button>
//         </div>

//         <div className="p-4 flex flex-col space-y-4 text-lg">
//           <Link to="/" onClick={() => setOpen(false)}>{t("Home")}</Link>
//           <Link to="/lottery" onClick={() => setOpen(false)}>{t("Lottery_Registration")}</Link>
//           <Link to="/gallary" onClick={() => setOpen(false)}>{t("Gallery")}</Link>
//           <Link to="/shop" onClick={() => setOpen(false)}>{t("Shop_Now")}</Link>
//           <Link to="/legal" onClick={() => setOpen(false)}>{t("Legal")}</Link>
//            <Link to="/terms" onClick={() => setOpen(false)}>{t("Terms and Conditions")}</Link>

//           <Link to="/dashboard" onClick={() => setOpen(false)}>{t("dashboard")}</Link>
//         </div>
//       </div>

//       {/* Language Toggle */}
//       <div className="px-4 py-2">
//         <LanguageToggle />
//       </div>
//     </nav>
//   );
// }





// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { HiMenu, HiX } from "react-icons/hi";
// import LanguageToggle from "./LanguageToggle";
// import { useTranslation } from "react-i18next";

// export default function Navbar() {
//   const [open, setOpen] = useState(false);
//   const location = useLocation();
//   const { t } = useTranslation();

//   const isActive = (path) => location.pathname === path;

//   return (
//     <nav className="bg-[#011B8A] text-white shadow-lg font-[600] tracking-wide">
//       <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">

//         <div className="text-xl font-bold">www.meruram.in</div>

//         <div className="hidden md:flex space-x-6 text-lg">
//           <Link to="/" className={`px-3 py-1 rounded-md ${isActive("/") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("home")}
//           </Link>

//           <Link to="/lottery" className={`px-3 py-1 rounded-md ${isActive("/lottery") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("lottery_registration")}
//           </Link>

//           <Link to="/gallary" className={`px-3 py-1 rounded-md ${isActive("/gallary") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("gallery")}
//           </Link>

//           <Link to="/shop" className={`px-3 py-1 rounded-md ${isActive("/shop") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("shop_now")}
//           </Link>

//           <Link to="/legal" className={`px-3 py-1 rounded-md ${isActive("/legal") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("legal")}
//           </Link>

//           <Link to="/terms" className={`px-3 py-1 rounded-md ${isActive("/terms") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("terms")}
//           </Link>

//           <Link to="/dashboard" className={`px-3 py-1 rounded-md ${isActive("/dashboard") ? "bg-blue-600" : "hover:text-yellow-300"}`}>
//             {t("dashboard")}
//           </Link>
//         </div>

//         <button className="md:hidden text-3xl" onClick={() => setOpen(true)}>
//           <HiMenu />
//         </button>
//       </div>

//       {open && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setOpen(false)}></div>
//       )}

//       <div
//         className={`fixed top-0 right-0 w-64 h-full bg-[#021066] text-white z-50 transform 
//           ${open ? "translate-x-0" : "translate-x-full"} transition-transform duration-300`}
//       >
//         <div className="p-4 flex justify-between items-center border-b border-blue-800">
//           <h2 className="text-lg font-semibold">{t("menu")}</h2>
//           <button onClick={() => setOpen(false)} className="text-3xl"><HiX /></button>
//         </div>

//         <div className="p-4 flex flex-col space-y-4 text-lg">
//           <Link to="/" onClick={() => setOpen(false)}>{t("home")}</Link>
//           <Link to="/lottery" onClick={() => setOpen(false)}>{t("lottery_registration")}</Link>
//           <Link to="/gallary" onClick={() => setOpen(false)}>{t("gallery")}</Link>
//           <Link to="/shop" onClick={() => setOpen(false)}>{t("shop_now")}</Link>
//           <Link to="/legal" onClick={() => setOpen(false)}>{t("legal")}</Link>
//           <Link to="/terms" onClick={() => setOpen(false)}>{t("terms")}</Link>
//           <Link to="/dashboard" onClick={() => setOpen(false)}>{t("dashboard")}</Link>
//         </div>
//       </div>

//       <div className="px-4 py-2">
//         <LanguageToggle />
//       </div>
//     </nav>
//   );
// }






import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import LanguageToggle from "./LanguageToggle";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (path) => location.pathname === path;

  const navItemClass = (path) =>
    `px-2 py-[2px] rounded-md text-sm transition
     ${isActive(path) ? "bg-blue-600" : "hover:text-yellow-300"}`;

  return (
    <nav className="bg-[#011B8A] text-white shadow-md font-medium">
      <div className="max-w-7xl mx-auto px-3 py-1 flex items-center justify-between">

        {/* LOGO */}
        <div className="text-base font-semibold whitespace-nowrap">
          www.meruram.in
        </div>

        {/* DESKTOP MENU */}
        <div className="hidden md:flex items-center space-x-3">
          <Link to="/" className={navItemClass("/")}>{t("home")}</Link>
          <Link to="/register" className={navItemClass("/register")}>{t("Registration")}</Link>
          <Link to="/businessplan" className={navItemClass("/businessplan")}>{t("Business Plan")}</Link>
          <Link to="/award" className={navItemClass("/award")}>{t("Awards")}</Link>
          <Link to="/gallary" className={navItemClass("/gallary")}>{t("gallery")}</Link>
          {/* <Link to="/shop" className={navItemClass("/shop")}>{t("shop_now")}</Link> */}
          <Link to="/legal" className={navItemClass("/legal")}>{t("legal")}</Link>
          <Link to="/terms" className={navItemClass("/terms")}>{t("terms")}</Link>
          <Link to="/contact" className={navItemClass("/contact")}>{t("Contact")}</Link>

          <Link to="/admin/login" className={navItemClass("/admin/login")}>{t("Login")}</Link>
        </div>

        {/* MOBILE MENU ICON */}
        <button className="md:hidden text-3xl" onClick={() => setOpen(true)}>
          <HiMenu />
        </button>
      </div>

      {/* MOBILE OVERLAY */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setOpen(false)}
        />
      )}

      {/* MOBILE DRAWER */}
      <div
        className={`fixed top-0 right-0 w-64 h-full bg-[#021066] text-white z-50 transform 
        ${open ? "translate-x-0" : "translate-x-full"} transition-transform duration-300`}
      >
        <div className="p-4 flex justify-between items-center border-b border-blue-800">
          <h2 className="text-lg font-semibold">{t("menu")}</h2>
          <button onClick={() => setOpen(false)} className="text-3xl">
            <HiX />
          </button>
        </div>

        <div className="p-4 flex flex-col space-y-4 text-base">
          <Link to="/" onClick={() => setOpen(false)}>{t("home")}</Link>
          <Link to="/register" onClick={() => setOpen(false)}>{t("Registration")}</Link>
          
       <Link to="/businessplan" onClick={() => setOpen(false)}>{t("Business Plan")}</Link>
          <Link to="/award" onClick={() => setOpen(false)}>{t("Awards")}</Link>
          <Link to="/gallary" onClick={() => setOpen(false)}>{t("gallery")}</Link>
          {/* <Link to="/shop" onClick={() => setOpen(false)}>{t("shop_now")}</Link> */}
          <Link to="/legal" onClick={() => setOpen(false)}>{t("legal")}</Link>
          <Link to="/terms" onClick={() => setOpen(false)}>{t("terms")}</Link>
          
          <Link to="/contact" onClick={() => setOpen(false)}>{t("Contact Us")}</Link>
          <Link to="/admin/login" onClick={() => setOpen(false)}>{t("Login")}</Link>
        </div>
      </div>

      {/* LANGUAGE TOGGLE */}
      <div className="px-3 py-1">
        <LanguageToggle />
      </div>
    </nav>
  );
}
